module.exports = __webpack_public_path__ + "static/media/sendFile.dccddb18.svg";